import loadingIcon from './assets/loading.svg';
import './button.scss';

export const Button = ({
  text,
  clickHandler,
  disabled,
  loading,
  className="button"
}) => {
  return (
    <div>
      <button className={className} onClick={clickHandler} disabled={disabled}>
        {loading && <img className="loading-img" src={loadingIcon} />}
        {text}
      </button>
    </div>
  );
};
